import React from "react";
import { Link } from "react-router-dom";
import backgroundImage from "../../../../assets/background-footer.png";
import IconVerified from "../../../../assets/verified.svg";
import useWindowDimensions from "../../../../misc/windowDimensions";

export default function FooterHero() {
  const { width } = useWindowDimensions();

  return (
    <div
      style={{
        // height: "70px",
        padding: "0px 0px",
        backgroundColor: "white",
      }}
    >
      <div className="container">
        <div
          style={{
            height: "1px",
            backgroundColor: "#E5E5E5",
            marginTop: "70px",
          }}
        />

        <div style={{ marginTop: "45px" }}>
          <div
            style={{
              backgroundImage: `url(${backgroundImage})`,
              height: "406px",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: width < 728 ? 'flex-start' : 'center'
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                marginBottom: 23
              }}
            >
              <img
                className="mb-0"
                src={IconVerified}
                alt="icon-verified"
                style={{ width: "15px", objectFit: "contain" }}
              />
              <p className="p-nunito" style={{margin: 0, marginLeft: 6}}>Penyelenggara Sertifikat Elektronik Indonesia</p>
            </div>
            <h1 className="h1-nunito" style={{maxWidth: 500, marginBottom: 42, textAlign: 'center'}}>Siap Untuk Beralih ke Layanan Digital Terpercaya?</h1>
            {/* <h1 className="h1-nunito" style={{maxWidth: 500, marginBottom: 42, textAlign: 'center'}}>Siap Untuk Beralih ke Layanan Digital Terpercaya? <span style={{color: '#1672BD'}}>TTE</span>?</h1> */}
            <div>
              <Link
                onClick={() => console.log("PENCET1")}
                style={{
                  backgroundColor: "#1672BD",
                  color: "white",
                  border: "1px solid #1672BD",
                }}
                className="nav-link btn p-nunito btn-instance"
                to="/listPSrE/_"
              >
                Lihat Daftar PSrE Indonesia
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
